import { defineComponent } from "vue";

import TypeaheadInput from "../TypeaheadInput/TypeaheadInput.vue";
import { ITypeaheadOptions } from "../../vue-interfaces/i-typeahead";

export default defineComponent({
    components: {
        TypeaheadInput
    },

    props: {
        enumList: {
            type: Array,
            default: []
        },
        prefillValue: {
            type: Number,
            default: null
        },
        placeholder: {
            type: String,
            default: "Start Typing..."
        }
    },

    data(vm) {
        return {
            typeaheadList: [],
            selectedValue: null as ITypeaheadOptions
        };
    },

    watch: {
        selectedValue(newValue: ITypeaheadOptions) {
            if (newValue && this.prefillValue !== parseInt(newValue?.value, 10)) {
                this.$emit("update:prefillValue", parseInt(newValue.value, 10));
            } else if (!newValue) {
                this.$emit("update:prefillValue", null);
            }
        }
    },

    emits: ["update:prefillValue"],

    mounted() {
        this.typeaheadList = this.enumList?.map((enumValue: any) => ({
            value: `${enumValue.value}`,
            name: enumValue.name
        }));
        if (!!this.prefillValue) {
            this.selectedValue = this.typeaheadList.find(
                (typeaheadOption) => this.prefillValue == parseInt(typeaheadOption.value, 10)
            );
        }
    }
});
